import { updateUserApi, getUserProfile } from 'apis/userApi';
import useAsync from 'hooks/base/useAsync';
import { isNil } from 'lodash';
import React from 'react';
import { message } from 'antd';
import GlobalStore from 'stores/globalStore';
import { useTranslation } from 'react-i18next';
import { setItem } from 'utils/local-storage';
import { USER_PROFILE } from 'utils/storage-keys';

interface UserUpdateParam {
  username: string;
  password?: string;
  new_password?: string;
  phone: string;
  address: string;
  date_of_birth: string;
}
interface TokenParam {
  token: string;
}

export const useUpdateUserApi = () => {
  const { status, execute, value } = useAsync(updateUserApi, false);

  const update = React.useCallback(
    ({
      username,
      password,
      new_password,
      phone,
      date_of_birth,
      address
    }: UserUpdateParam) => {
      execute(username, password, new_password, phone, date_of_birth, address);
    },
    [execute]
  );

  React.useEffect(() => {
    if (isNil(value)) {
      return;
    }

    if (value.error) {
      console.log(value)
      message.error(value.errorMessage);
      return;
    }

    if (isNil(value.data)) {
      // message.warn('Empty Body');
      return;
    }

    // message.success('Cập nhật thành công');
    window.location.href = ('/user');
  }, [value]);

  return {
    isLoading: status === 'pending',
    update,
    response: value
  };
};

export const useGetUserProfileApi = () => {
  const { status, execute, value } = useAsync(getUserProfile, false);
  const { session, signOut } = GlobalStore.useContainer();
  const { t } = useTranslation();
  React.useEffect(() => {
    execute(session);
  }, [execute, session]);

  const getUserProfileApi = React.useCallback(
    (params: TokenParam) => {
      execute(params.token);
    },
    [execute]
  );

  React.useEffect(() => {
    if (isNil(value)) {
      return;
    }

    if (value.error) {
      switch(value.statusCode) {
        case 400:
          message.error(t('update.status_400'));
          break;
        case 401:
          message.error(t('update.status_401'));
          signOut();
          break;
        case 500:
          message.error(t('update.status_500'));
          break;
      }
      return;
    }

    if (value.data) {
      setItem(USER_PROFILE, JSON.stringify(value.data));
    }
  }, [value, t, signOut]);

  return {
    isLoading: status === 'pending',
    getUserProfileApi,
    profileObject: value
  };
};
